import { useEffect, useRef, useState } from 'react';

import type { Lang, Question } from '@/api';
import { useLang } from '@/lang';

export function useLangSyncedQuestions(
  initial: Question[],
  initialLang: Lang,
  fetchIn: (lang: Lang) => Promise<Question[]>,
) {
  const { lang } = useLang();
  const [questions, setQuestions] = useState(initial);
  const loadedLang = useRef(initialLang);

  useEffect(() => {
    if (lang === loadedLang.current) return;
    let cancelled = false;
    fetchIn(lang)
      .then((fresh) => {
        if (cancelled) return;
        loadedLang.current = lang;
        const byId = new Map<string, Question>(fresh.map((q) => [q.id, q]));
        setQuestions((old) => old.map((q) => byId.get(q.id) ?? q));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [lang, fetchIn]);

  return questions;
}
